<template>
    <div v-if="notifications.length" class="grid gap-y-2">
        <Card class="p-0" v-for="notification in notifications" :key="notification.title">
            <template #title>
                <h6 class="text-lg mb-2">{{ notification.title }}</h6>
                <hr>
            </template>
            <template #content>
                <div class="mt-2    ">
                    <div class="text-base" v-html="notification.content"></div>                    
                    <p class="text-end mt-1 font-bold text-sm">{{ new Date(notification.date).toLocaleDateString("en-US") }}</p>
                </div>
            </template>
        </Card>
    </div>
    <Card v-else>
        <template #content>
            <h6 class="text-lg font-bold text-center py-2">
                No recent notifications
            </h6>
        </template>
    </Card>
</template>

<script setup lang="ts">
import Card from 'primevue/card';
import Notification from "@/classes/Notification"

const props = defineProps<{
    notificationsCount: number,
    notifications: Notification[],
}>()


</script>